import { Popover, Text } from "@mantine/core";
import { useState } from "react";

type PopoverTextProps = {
  children: string;
  withArrow?: boolean;
  position?: "top" | "left" | "bottom" | "right";
};

export function PopoverText({ children, withArrow = true, position = "top" }: PopoverTextProps) {
  const [opened, setOpened] = useState(false);
  const shouldTruncate = children.length > 18;
  const truncatedText = shouldTruncate ? `${children.substring(0, 18)}...` : children;

  if (!shouldTruncate) {
    return (
      <Text size="sm" w="max-content">
        {children}
      </Text>
    );
  }

  return (
    <Popover width="max-content" position={position} withArrow={withArrow} shadow="sm" opened={opened}>
      <Popover.Target>
        <Text size="sm" w="max-content" onMouseEnter={() => setOpened(true)} onMouseLeave={() => setOpened(false)}>
          {truncatedText}
        </Text>
      </Popover.Target>
      <Popover.Dropdown onMouseEnter={() => setOpened(true)} onMouseLeave={() => setOpened(false)}>
        <Text size="sm" w="max-content">
          {children}
        </Text>
      </Popover.Dropdown>
    </Popover>
  );
}
